import { defineComponent as _defineComponent } from 'vue'
import { normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "header-wrapper" }
const _hoisted_2 = ["href"]

import SaveAndContinueLater from '@/profile-creation-wizard/common/ui/save-and-continue/SaveAndContinueLater.vue';
    import {useTranslation} from '@malt/vue3-use';
    import {computed} from 'vue';
    import {useRoute} from 'vue-router';
    import {useStore} from 'vuex';
    import {ProfileCreationStepGroup} from '../config/steps/ProfileCreationSteps';

    const MaltLogoPath = '//dam.malt.com/rebranding2020/malt-logo/malt-red';
    const MaltStrategyLogoPath = '//dam.malt.com/rebranding2020/various-logos/malt-strategy.svg?vh=88b1c9';

    
export default /*@__PURE__*/_defineComponent({
  __name: 'Header',
  setup(__props) {

    const route = useRoute();
    const store = useStore();
    const {msg} = useTranslation();

    const logoLink = computed(() => (isMaltStrategy.value ? '/c/maltstrategy/consultants' : '/'));
    const isMaltStrategy = computed(() => store.state.isFunnelStrategy);
    const showButtonBack = computed(
        () => isMaltStrategy.value && route.meta.stepNumber === 1 && route.meta.stepGroup != ProfileCreationStepGroup.WAITING_ROOM,
    );

    const imageProps = computed(() => {
        const height = isMaltStrategy.value ? '33' : '60';
        const width = isMaltStrategy.value ? '236' : '125';
        const alt = `malt ${isMaltStrategy.value ? 'strategy ' : ''}logo`;
        const src = isMaltStrategy.value ? MaltStrategyLogoPath : MaltLogoPath;

        return {height, width, alt, src};
    });

    function backToMalt(): void {
        window.location.href = '/';
    }

return (_ctx: any,_cache: any) => {
  const _component_VJoyButton = _resolveComponent("VJoyButton")!
  const _component_VJoyWrapper = _resolveComponent("VJoyWrapper")!

  return (_openBlock(), _createBlock(_component_VJoyWrapper, {
    class: "header-wrapper-fixed",
    "no-margin": ""
  }, {
    default: _withCtx(() => [
      _createElementVNode("header", _hoisted_1, [
        _createElementVNode("a", {
          href: logoLink.value,
          class: "header-logo"
        }, [
          _createElementVNode("img", _normalizeProps(_guardReactiveProps(imageProps.value)), null, 16)
        ], 8, _hoisted_2),
        (showButtonBack.value)
          ? (_openBlock(), _createBlock(_component_VJoyButton, {
              key: 0,
              variant: "ghost",
              onClick: backToMalt
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_unref(msg)('profile.creation.wizard.strategy.introduction.redirection.to.website.link')), 1)
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        _createVNode(SaveAndContinueLater)
      ])
    ]),
    _: 1
  }))
}
}

})